export const getColorStatusClasses = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'finalizado':
      return 'bg-green-100 text-green-800';
    case 'en proceso':
      return 'text-orange-800 bg-orange-100';
    case 'pendiente':
      return 'text-orange-800 bg-orange-100';
    case 'ok':
      return 'bg-green-100 text-green-800 ';
    default:
      return 'text-gray-800 bg-gray-100';
  }
};
